import request from '../utils/request.js'
import {
  studyService,
  operateService,
  userService,
  healthyService
} from '@/config/gateway.js'
/**
 * 省市区区域接口
 * @param params
 * @returns {AxiosPromise}
 */
export function listDistricts(params) {
  return request({
      url: healthyService + '/dictionary/listDistricts',
      method: 'post',
      data: params
  })
}

/**
 * 教研标签
 * @param params
 * @returns {AxiosPromise}
 */
export function resTages(params){
  return request({
    url: studyService+'/researchTag/listByParentId',
    method: 'post',
    data: params
  })
}
/**
 * 根据关键字获取字典
 * @param params
 * @returns {AxiosPromise}
 */
export function getKeyMap(params = []) {
  return request({
      url: healthyService + '/base/basicDictionary/get',
      method: 'post',
      data: {key:params}
  })
}
export function pageList(params) {
  return request({
      url: userService + "/userNurse/listUserNurse",
      method: 'post',
      data: params
  })
}

/**
 * 登录
 * @param params
 * @returns {AxiosPromise}
 */
export function login(params) {
  return request({
      url: healthyService + '/manager/login',
      method: 'post',
      data: params
  })
}


/**
 * 手机号登录
 * @param params
 * @returns {AxiosPromise}
 */
export function loginByVerifyCode(params) {
  return request({
    url: healthyService + '/manager/loginByVerifyCode',
    method: 'post',
    data: params
  })
}
/**
 * 手机号登录发送验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function loginSendVerifyCode(params) {
  return request({
    url: healthyService + '/manager/loginSendVerifyCode',
    method: 'post',
    data: params
  })
}


/**
 * 退出
 * @param params
 * @returns {AxiosPromise}
 */
export function logout(params) {
  return request({
      url: healthyService + '/manager/loginOut',
      method: 'post',
      data: params
  })
}


/**
 * 修改密码
 * @param params
 * @returns {AxiosPromise}
 */
export function changePassword(params) {
  return request({
      url: operateService + '/org/account/changePassword',
      method: 'post',
      data: params
  })
}

/**
 * 机构后台，点击返回调用，管理员解绑机构（记忆功能）
 * @param params
 * @returns {AxiosPromise}
 */
export function unBindManagerOperaOrg(params) {
  return request({
    url: healthyService + '/org/info/admin/unBindManagerOperaOrg',
    method: 'post',
    data: params
  })
}

/**
 * 机构列表点击进入调用，管理员绑定机构（记忆功能）
 * @param params
 * @returns {AxiosPromise}
 */
export function bindManagerOperaOrg(params) {
  return request({
    url: healthyService + '/org/info/admin/bindManagerOperaOrg',
    method: 'post',
    data: params
  })
}

/**
 * 更新阅读协议为已读
 * @param params
 * @returns {AxiosPromise}
 */
export function updateManagerReadAgreement(params) {
  return request({
    url: healthyService + '/permission/orgManager/updateManagerReadAgreement',
    method: 'post',
    data: params
  })
}

export function sendSMS(params) {
    return request({
        url: '/pc/sendsms',
        method: 'get',
        params: params
    })
}
